import React from "react";

import { Box, Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";

import nutricoachLogo from "@assets/Nutricoach.png";
import Spacer from "@components/layout/Spacer";

const RegisterSuccessPage: React.FC = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      margin="auto"
      maxWidth={1020}
      height="100vh"
    >
      <Spacer pxVertical={65} />
      <img src={nutricoachLogo} alt="nutricoach full logo" />
      <Typography variant="h4">Confirm Your Account</Typography>
      <Box mb={2} />
      <Typography variant="body1">
        We&apos;ve sent you confirmation instructions to your email address.
      </Typography>
      <Box mb={4} />
      <Button component={Link} to="/" size="large">
        Return to login
      </Button>
    </Box>
  );
};

export default RegisterSuccessPage;
